<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2" id="resume-news">
    <div
      class="flex h-32 overflow-hidden rounded-lg shadow"
      v-for="(resume, index) in resumes"
      :key="index"
    >
      <img :src="resume.img" class="flex-none object-cover w-32 h-32" />
      <div class="flex flex-col w-full gap-1 p-2 bg-white">
        <div class="">
          <a :href="resume.publication.category.links.url">
            <small class="font-semibold text-default-500 hover:text-default-600">
              {{ resume.publication.category.name }}
            </small>
          </a>
        </div>
        <a :href="resume.links.url" class="grow hover:text-default-600">
          <h6 class="text-sm">{{ resume.title }}</h6>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import News from "../api/models/News";
import { ref } from "vue";
export default {
  name: "NewsResumeComponent",
  setup() {
    const resumes = ref([]);
    News.resumes().then((response) => {
      resumes.value = response.data;
    });
    return {resumes};
  },
};
</script>

<style scoped>
#resume-news p {
  font-size: 0.75rem;
  color: #777;
  position: absolute;
  bottom: 0;
  right: 0.75rem;
}
#resume-news .card {
  background-size: auto 100%;
  background-repeat: no-repeat;
}
#resume-news .card-body {
  background: linear-gradient(to right, transparent, #fff 33%);
}
#resume-news .datetime {
  font-size: xx-small;
}
</style>
